import * as zod from 'zod';

export const WristCameraState = zod.object({
  kind: zod.literal('WristCamera'),
  connected: zod.boolean(),
});

export type WristCameraState = zod.infer<typeof WristCameraState>;
